import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Quote } from 'lucide-react';
const studies = [{
  institution: 'Smithsonian Institution',
  quote: 'The ability to order small batches allowed us to test designs for our new exhibit without risk. The best sellers were restocked within days.',
  image: 'https://images.unsplash.com/photo-1564399579883-451a5d44ec08?w=600&h=400&fit=crop',
  metric: '40%',
  metricLabel: 'Revenue Increase'
}, {
  institution: 'Denver Art Museum',
  quote: 'We needed custom merchandise for a pop-up exhibition with only two weeks notice. Museum Store Products delivered early.',
  image: 'https://images.unsplash.com/photo-1518998053901-5348d3961a04?w=600&h=400&fit=crop',
  metric: '5 Days',
  metricLabel: 'Production Time'
}, {
  institution: '9/11 Memorial & Museum',
  quote: 'The quality of the commemorative items for the 20th anniversary was exceptional. Truly museum-grade manufacturing.',
  image: 'https://images.unsplash.com/photo-1582555172866-f73bb12a2ab3?w=600&h=400&fit=crop',
  metric: '20th',
  metricLabel: 'Anniversary Collection'
}];
export function CaseStudies() {
  return <section className="py-24 bg-museum-gray" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-51">
          <div data-id="element-52">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-museum-black tracking-tight mb-4" data-id="element-53">
              Partner Success Stories
            </h2>
            <p className="text-xl text-museum-subtle max-w-xl" data-id="element-54">
              See how cultural institutions are growing their retail revenue
              with custom merchandise.
            </p>
          </div>
          <a href="#" className="inline-flex items-center text-museum-blue font-semibold hover:text-museum-dark transition-colors group" data-id="element-55">
            View All Stories
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-56" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-57">
          {studies.map((study, index) => <motion.div key={study.institution} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-500 group" data-id="element-58">
              {/* Image */}
              <div className="aspect-[3/2] overflow-hidden relative" data-id="element-59">
                <img src={study.image} alt={study.institution} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-60" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-61"></div>

                {/* Metric badge */}
                <div className="absolute bottom-4 left-4 bg-white rounded-xl px-4 py-2 shadow-lg" data-id="element-62">
                  <div className="text-2xl font-serif font-bold text-museum-blue" data-id="element-63">
                    {study.metric}
                  </div>
                  <div className="text-xs text-museum-subtle font-medium" data-id="element-64">
                    {study.metricLabel}
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8" data-id="element-65">
                <Quote className="w-8 h-8 text-museum-gray mb-4" data-id="element-66" />
                <blockquote className="text-museum-subtle mb-6 leading-relaxed" data-id="element-67">
                  "{study.quote}"
                </blockquote>
                <div className="font-serif font-bold text-museum-black" data-id="element-68">
                  {study.institution}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}